import { render, staticRenderFns } from "./OneSeat.vue?vue&type=template&id=0df42b0a"
import script from "./OneSeat.vue?vue&type=script&lang=js"
export * from "./OneSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports